import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import { DialogEnum, useActionDialogContext } from '../../Context/ActionDialogContext';
import { Button, Spinner } from '@/Components/shadcn';

function HireActions(): React.JSX.Element {
    const { hideDialog, showHireNotification, hireApplicantAsync, isHireLoading } = useActionDialogContext();

    const closeHireDialog = () => {
        hideDialog(DialogEnum.Hire);
    };

    return (
        <Button
            className="w-full"
            size="lg"
            variant="default"
            disabled={isHireLoading}
            onClick={async () => {
                await hireApplicantAsync();
                closeHireDialog();
                showHireNotification();
            }}
        >
            {isHireLoading && <Spinner data-icon="inline-start" />}
            {UIStrings.MarkAsHired}
        </Button>
    );
}

export default HireActions;
